// ABOUTME: Auto-resizing textarea component
// ABOUTME: Automatically adjusts height based on content

import * as React from "react"
import { TextareaBase } from "./CTextarea"
import { cn } from "@shared/lib/utils"
import { FIELD_SIZING_STYLE, resizeTextArea, useAutoSizeTextArea } from "@shared/hooks/useAutoSizeTextArea"

interface CAutoSizeTextAreaProps {
  onChange?: (e: React.SyntheticEvent) => void
  value: string
  placeholder?: string
  disabled?: boolean
  height?: string | number
  className?: string
  classNameWrap?: string
  color?: string
  helperText?: string | null
  id?: string
  onBlur?: () => void
  autoFocus?: boolean
  style?: React.CSSProperties
}

const colorClasses: Record<string, string> = {
  failure: "border-red-500 focus-visible:ring-red-500",
  success: "border-green-500 focus-visible:ring-green-500",
  warning: "border-yellow-500 focus-visible:ring-yellow-500",
}

export const CAutoSizeTextArea: React.FC<CAutoSizeTextAreaProps> = (props) => {
  const { height, onChange, className, classNameWrap, value, style, color, helperText, ...args } = props
  const textRef = useAutoSizeTextArea(value, height)

  const onChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e)
  }

  const onFocusHandler = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    resizeTextArea(e.target)
  }

  const computedStyle = {
    ...style,
    ...(height ? { minHeight: typeof height === "number" ? `${height}px` : height } : {}),
    ...FIELD_SIZING_STYLE,
  } as React.CSSProperties

  return (
    <div className={cn("w-full", classNameWrap)}>
      <TextareaBase
        value={value || ""}
        ref={textRef}
        onChange={onChangeHandler}
        onFocus={onFocusHandler}
        {...args}
        style={computedStyle}
        className={cn(
          "w-full resize-y overflow-hidden min-h-[64px] !p-2 bg-white",
          color && colorClasses[color],
          className,
        )}
      />
      {helperText && (
        <p className={cn("mt-1 text-sm", color === "failure" ? "text-red-600" : "text-gray-500")}>{helperText}</p>
      )}
    </div>
  )
}
